export const secret = "Ftp@)2%jsj@*";

export const banks = [
  {
    id: 1,
    name: "Alior Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 2,
    name: "Bank Polskiej Spółdzielczości S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 3,
    name: "Millennium Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 4,
    name: "Bank Polska Kasa Opieki SA (Pekao S.A.)",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 5,
    name: "BNP Paribas Bank Polska S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 6,
    name: "Bank Ochrony Środowiska S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 7,
    name: "Bank Handlowy w Warszawie S.A. (Citi Handlowy)",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 8,
    name: "ING Bank Śląski S.A.",
    alert: "warning",
    desc: "obserwujemy, że umowy tego banku oraz udzielane zobowiązania są w większości zgodne z prawem, zdecydowanie kontynuuj wypełnianie formularza oraz porozmawiaj z naszym ekspertem celem dokładniejszego zbadania przypadku",
  },
  {
    id: 9,
    name: "mBank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 10,
    name: "Powszechna Kasa Oszczędności Bank Polski S.A. (PKO BP)",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 11,
    name: "Santander Bank Polska",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 12,
    name: "Credit Agricole Bank Polska S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 13,
    name: "Bank Pocztowy S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 14,
    name: "Deutsche Bank Polska S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 15,
    name: "Bank DNB Bank Polska S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 16,
    name: "Euro Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 17,
    name: "Getin Noble Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 18,
    name: "Inteligo (PKO BP S.A.)",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 19,
    name: "Nest Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 20,
    name: "Raiffeisen Bank Polska S.A. (Polbank)",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 21,
    name: "Toyota Bank Polska S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 22,
    name: "Volkswagen Bank GmbH Sp. z o.o. Oddział w Polsce",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 23,
    name: "SGB Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 24,
    name: "Citi Handlowy S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 25,
    name: "Plus Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 26,
    name: "Bank Spółdzielczy",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 27,
    name: "Noble Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 28,
    name: "Bank Zachodni WBK S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 29,
    name: "Santander Consumer Bank Polska S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 30,
    name: "Nordea Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 31,
    name: "BGŻ BNP Paribas S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 32,
    name: "Ikano Bank AB S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 33,
    name: "SKOK im. Franciszka Stefczyka",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 34,
    name: "Cofidus S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 35,
    name: "VeloBank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 36,
    name: "Bank Pekao S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 37,
    name: "Bank Handlowy w Warszawie S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 38,
    name: "Raiffeisen Bank Polska S.A",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 39,
    name: "TF BANK AB",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 40,
    name: "Bank BPH S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 41,
    name: "Nest Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 42,
    name: "Meritum Bank ICB S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 43,
    name: "Plus Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 44,
    name: "BRE Bank S.A.",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
  {
    id: 45,
    name: "Inny",
    alert: "positive",
    desc: "wiele kancelarii skutecznie prowadzi sprawy sądowe przeciwko temu bankowi, pomożemy Ci wybrać najlepszą z nich",
  },
];
